
export default function (scope, element, attrs) {
	var onChange = _ => scope.$eval(attrs.fileChange);

	element[0].addEventListener('change', onChange, false);

	scope.$on('$destroy', _ => {
		element[0].removeEventListener('change', onChange, false);
	});
}



// WEBPACK FOOTER //
// ./src/directive/file-change/file-change.link.js